import React from 'react'
import { Container } from 'react-bootstrap';
import './navbar/navbar.css';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';

import img7 from "../assets/images/hacene.jpg";
import img6 from "../assets/images/raouf.jpg";
import img8 from "../assets/images/ayoub.jpg";
import img9 from "../assets/images/sofianee.png";

export default function Talks() {
    const [checked, setChecked] = React.useState(["trainer-paper","trainer-paper", "trainer-paper", "trainer-paper", "trainer-paper","trainer-paper", "trainer-paper", "trainer-paper", "trainer-paper"]);
  
    
    const updateFieldChanged = index => e => {
        let tempArr = [...checked];
        tempArr[index] = "trainer-paper-opened";
        setChecked(tempArr)
    }
    const updateFieldChangedOpened = index => e => {
        let tempArr = [...checked];
        tempArr[index] = "trainer-paper";
        setChecked(tempArr)
    }
   
    const trainers = [
       {
            source: img6,
            name: "Abderaouf Gacem",
            job: "PhD Candidate at LIRIS-INSA-Lyon",
        
            linkedInUrl: " https://www.linkedin.com/in/abderaouf-gacem",
            twitterUrl: "https://twitter.com/AbderaoufGacem",
        },{
            source: img7,
            name: "Ghouthli Boukli Hacene",
            job: "",
       
            linkedInUrl: "https://www.linkedin.com",
            twitterUrl: "https://twitter.com/",
        },{
            source: img8,
            name: "Ayoub Benaissa",
            job: "Working at OpenMined",

            linkedInUrl: "https://www.linkedin.com/in/ayoub-benaissa/",
            twitterUrl: "https://twitter.com/y0uben11",
        }
        ,{
            source: img9,
            name: "Sofiane Yous",
            job: "Leader of SW/HW co-design for Intel Edge-AI platforms",
            linkedInUrl: "https://www.linkedin.com/in/sofianeyous/",
            twitterUrl: "",
        },
    ]
    return (
        <section id="Trainers">
            <Container className="trainer-container" >
                <h1>Our Talks</h1>
                <Grid container className="" spacing={1}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={8}>
                            {trainers.map((trainer, index) => (

                                <Grid key={index} item>

                                    <Paper className={checked[index]} >
                                        <Avatar className="trainer-img" alt="Remy Sharp" src={trainer.source} />
                                        {(checked[index] !== "trainer-paper-opened") ?
                                            <IconButton className="card-extend" onClick={updateFieldChanged(index)}

                                                color="primary" aria-label=" " component="span">
                                                <ExpandMoreIcon className="extend-card" />
                                            </IconButton>
                                            : <>
                                                <div className="card-text-container">
                                                    <h1>{trainer.name}</h1>
                                                    <h4>{trainer.job}</h4>
                                                </div>
                                                <div>
                                                    
                                                   
                                                    <a href={trainer.linkedInUrl} target="_blank" rel="noreferrer">
                                                        <IconButton
                                                            className="social" aria-label=" " component="span">
                                                            <LinkedInIcon />
                                                        </IconButton>
                                                    </a>
                                                    <a href={trainer.twitterUrl} target="_blank" rel="noreferrer">
                                                        <IconButton
                                                            className="social" aria-label=" " component="span">
                                                            <TwitterIcon />
                                                        </IconButton>
                                                    </a>
                                                </div>
                                                <IconButton className="card-extend" onClick={updateFieldChangedOpened(index)}

                                                    color="primary" aria-label=" " component="span">
                                                    <ExpandLessIcon className="extend-card" />
                                                </IconButton>
                                            </>

                                        }

                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                </Grid>
            </Container>

        </section>
    )

}

